import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import * as s from './loading.module.css'

interface LoadingProps {
  show: boolean
}

const Loading: React.FC<LoadingProps> = ({ show }) => {
  return <>
    {show && <div className={s.loadingMask} >
      <FontAwesomeIcon className={s.svg} icon={faCircleNotch} pulse />
    </div>}
  </>
}

export {Loading}